import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class IssueDateEarlierThanAdjustedError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.issue-date.earlier-than-adjusted');
    }
}
